import cookie from "cookie";
import { removeAccessToken } from "./cookieHelper";
import { withIronSessionApiRoute } from "iron-session/next";
import { sessionOptions } from "./session";

const nextLogout = withIronSessionApiRoute(async (req, res) => {
    try {
        let cookieValue: any = removeAccessToken();

        res.setHeader("Set-Cookie", [cookieValue]);

        req.session.destroy();
        res.send(JSON.stringify({ isLoggedIn: false }));
    } catch (error) {
        console.log("Logout Error", error);
        res.send(JSON.stringify(error));
    }
}, sessionOptions);

export { nextLogout };

// res.send(JSON.stringify({ isLoggedIn: false }));
// res.statusCode = 302;
// res.setHeader('Location', req.headers.referer || '/');
